import { useState, useEffect, useContext } from "react";
import { SideMenu } from "../../components/side_menu/inline_side_menu.component";
import { DataTable } from "../../components/data_table/data_table.component";
import OverLay from "../../components/side_menu/overlay_side_menu.component";
import { OverflowSetCustomExample } from "../../components/side_menu/overFlowSet.component";
import { Stack, StackItem } from "@fluentui/react";
import { CSVLink } from 'react-csv';
import { MenuItem, Button, MenuList, MenuButton, Divider, Text, Body1Strong, Body1, Caption1, FluentProvider, webLightTheme, Input, Tooltip } from "@fluentui/react-components";
import { Filter20Filled, FilterDismiss20Filled, ArrowClockwise20Regular, ArrowDownload20Regular, Dismiss16Regular, DesktopCheckmark20Regular, WrenchScrewdriver20Regular, AlertBadge20Regular, CheckmarkLock20Regular } from "@fluentui/react-icons";
import { Breadcrumbs } from "../../components/breadcrumbs/breadcrumbs.component";
import { Pagination } from "../../components/pagination/pagination.component";
import { useNavigate } from "react-router-dom";
import { MenuDropdown } from "../../components/dropdown/menu.component";
import { DropdownComponent } from "../../components/dropdown/dropdown.component";
import { FullScreen, useFullScreenHandle } from "react-full-screen"
import { lightTheme, primaryIcon, secondaryIcon, buttonContent, heightResponsive, DynamicBoxingCSS, parentHome, wraperStyle, SubSectionResponsive, responsiveHight, paddingTop, dashboardTheme, BreadcrumbsBorder } from "../../styles/customStyles";
import { usePermissionStore } from "../../Store/permissionStore";
import { GlobalContext } from "../../hooks/globalContext";
import { SkeletonDataTable } from "../../components/skeleton/skeletonDataTable";
import FullScreenButton from "../../components/fullscreen/fullScreen.component";
import { SearchBar } from "../../components/searchbar/searchbar.component";
import { InfoBar } from "../../components/infoBar/infoBar.component";
import { TroubleshootPages } from "../../components/side_menu/InlineSidenav";
import { ToastComponent } from "../../components/toast/toast.component";

export const Alert = () => {
    const navigate = useNavigate();
    const handle = useFullScreenHandle();
    const contextValue: any = useContext(GlobalContext);
    const tenantName = contextValue.tenantName;
    const [isRefresh, setIsRefresh]: any = useState(false);
    const [tableData, setTableData] = useState([]);
    const [leftOpenSubMenu, setleftOpenSubMenu] = useState(true);
    const [overlayOpen, setOverlayOpen] = useState(false);
    const [searchVal, setSearchVal] = useState("");
    const [totalPages, setTotalPages] = useState(1);
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [exportData, setExportData] = useState([]);
    const [filterMenuOpen, setFilterMenuOpen] = useState(false);
    const [isfilter, setIsFilter] = useState(false);
    const [isResetDisabled, setResetDisabled] = useState(true);
    const [filterArray, setFilterArray] = useState<string[]>([]);
    const [dropDownValue1, setDropDownValue1] = useState<any>();
    const [dropDownValue2, setDropDownValue2] = useState<any>();
    const { permissions } = usePermissionStore();
    const [loading, setLoading] = useState(true);
    /** @TODO : Change the state depending on the @PINOT response, in the below hook */
    const [refreshToast, setRefreshToast]: any = useState(false); 
    const [isToast, setIsToast] = useState(false);
    const [refreshing, setRefreshing] = useState(false);
    const handleRefresh = () => {
      setRefreshing(true);
      setRefreshToast(true);
      setLoading(true);
    };


    const handleFilterArray = (): any => {
        const value1 = dropDownValue1;
        const value2 = dropDownValue2;
        // Check if the column is already filtered
        const columnExists = filterArray.some(filter => filter.startsWith(`${value1} :`));
        if (!columnExists) {
            const result = value1 + " : " + value2;
            setFilterArray([...filterArray, result]);
            setIsFilter(true);
            setLoading(true);
            setDropDownValue1('');
            setDropDownValue2('');
        }
    };

    const handleCloseFilter = (index: any): any => {
        console.log("clicked");
        const updatedArray = filterArray.filter((x, itemIndex) => itemIndex !== index);
        setFilterArray(updatedArray);
        setLoading(true);
    }

    useEffect(() => {
        setResetDisabled(filterArray.length > 0 ? false : true);
    }, [filterArray]);

    const inputChange = (e: any) => {
        const enteredValue = e.target.value;
        console.log("entered value", enteredValue)
        let name = e.target.name;
        const regexS = /^[A-Za-z ]*$/;
        const regexSN = /^[A-Za-z0-9_-]*$/;
        const regexN = /^[0-9\.]*$/;
        if (name === 'filter' && dropDownValue1 === ("Alert Name")) {
            if (regexS.test(enteredValue)) {
                setDropDownValue2(enteredValue);
            }
        }
        if (name === 'filter' && dropDownValue1 === ("Number of Alerts")) {
            if (regexN.test(enteredValue)) {
                setDropDownValue2(enteredValue);
            }
        }
    }

    //data table column name code starts here
    var columns = [
        { key: "notification_name", label: <Body1Strong> Alert Name </Body1Strong> },
        // { key: "monitor_date", label: <Body1Strong> Monitor Date  </Body1Strong> },
        { key: "num_of_devices", label: <Body1Strong> Number of Alerts </Body1Strong> }
    ];
    //data table column name code ends here

    //data table for filter
    var columns1 = [
        { key: "notification_name", label: <Caption1> Alert Name </Caption1> },
        // { key: "num_of_devices", label: <Caption1> Number of Alerts </Caption1> },
    ];

    // overflow set contents code starts here
    var overFlowComponent = {
        data:
            <>
                <StackItem>
                    <Button shape="circular" disabled={loading} appearance="subtle" size="small" onClick={handleRefresh}>
                        <Stack tokens={{ childrenGap: 5 }} horizontal>
                            <StackItem> {loading ? <ArrowClockwise20Regular {...secondaryIcon} /> : <ArrowClockwise20Regular {...primaryIcon} />} </StackItem>
                            <StackItem> <Caption1> Refresh </Caption1> </StackItem>
                        </Stack>
                    </Button>
                </StackItem>

                {permissions.includes("all") || permissions.includes("tshootAlert_ReadandExport") || permissions.includes("tshootAlert_Fullaccess") ?
                    <StackItem>
                        <CSVLink id="csv-export-link" data={exportData} filename={`${tenantName}_compliance_Policies_assignmentlist.csv`}>
                            <Button shape="circular" disabled={loading || tableData.length === 0} appearance="subtle" size="small" onClick={() => setCurrentPageNo(1)}>
                                <Stack tokens={{ childrenGap: 5 }} horizontal>
                                    <StackItem>{loading || tableData.length === 0 ? <ArrowDownload20Regular {...secondaryIcon} /> : <ArrowDownload20Regular {...primaryIcon} />} </StackItem>
                                    <StackItem> <Caption1> Export </Caption1> </StackItem>
                                </Stack>
                            </Button>
                        </CSVLink>
                    </StackItem>
                    :
                    <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
                        <Button shape="circular" appearance="subtle" size="small" disabled>
                            <Stack tokens={{ childrenGap: 5 }} horizontal>
                                <StackItem><Text></Text></StackItem>
                                <StackItem>
                                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                                        <StackItem> <ArrowDownload20Regular {...secondaryIcon} /> </StackItem>
                                        <StackItem><Caption1> Export </Caption1></StackItem>
                                    </Stack>
                                </StackItem>
                            </Stack>
                        </Button>
                    </Tooltip>
                }

                {/* <StackItem>
          <Button shape="circular" appearance="subtle" size="small">
            <Stack tokens={{childrenGap:5}} horizontal>
              <StackItem> <Settings20Regular {...primaryIcon}/> </StackItem>
              <StackItem> <Caption1> Manage View </Caption1> </StackItem>
            </Stack>
          </Button>
        </StackItem> */}
        <StackItem grow shrink>
            <Stack horizontalAlign="end">
            <StackItem grow shrink>
                <FullScreenButton handle={handle} />
            </StackItem>
            </Stack>
        </StackItem>
            </>
        ,
    };
    // overflow set contents code ends here

    useEffect(() => {
        // const tenantName = 'Demo_Nanoheal';
        const tenantName = contextValue.tenantName;

        const fetchData = async () => {
            const apiUrl = 'https://pinot-dev.nanoheal.work/sql';

            // If searchVal exists, modify the SQL query to include search filter
            var whereCondition = '';
            if (searchVal) {
                whereCondition = ` AND alertname LIKE '%${searchVal}%' `;
            }

            if ((contextValue?.logedInFrom !== undefined || contextValue?.logedInFrom?.device?.length !== undefined) && contextValue?.logedInFrom?.device?.length > 0) {
                whereCondition += ` AND machine LIKE '%${contextValue?.logedInFrom?.device}%' `;
            }

            let sqlQuery = `select count(*), name from t1_312_notification where customer= '${tenantName}' ${whereCondition} group by name`;
            // let sqlQuery = `select count(*), alertname, scrip from t1_d177_notification where customer= '${temptenantName}' ${whereCondition} group by alertname, scrip`;

            // sqlQuery += ' limit 1000';

            const requestBody = {
                sql: sqlQuery,
                trace: false,
                queryOptions: '',
            };

            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestBody),
            });

            if (!response.ok) {
                throw new Error(`No result`);
            }

            const responseData = await response.json();
            console.log("responseData=", responseData);

            let rowData = responseData != undefined && responseData?.resultTable != undefined ? responseData?.resultTable?.rows : [];
            console.log("checking the ROWDATA", rowData)
            const uniqueData: any = [];
            //search functionality implementation
            if (searchVal) {
                const query = searchVal?.toLowerCase();
                let strVal = ''
                rowData = rowData.filter((val: any) => {
                    strVal = val[1].toLowerCase()
                    console.log("bigdata1", strVal)
                    return strVal.includes(query)
                    // console.log("BIGDATA2",strVal.includes(query))
                })
                console.log("DATATEST++++", rowData)
            }

            if (rowData?.length > 0) {

                rowData?.map((row: any) => {
                    const isDuplicate = uniqueData.some((existingRow: any) =>
                        JSON.stringify(existingRow) === JSON.stringify(row)
                    );
                    if (!isDuplicate) {
                        uniqueData.push(row);
                    }
                });

                var cnt = 0;
                uniqueData !== undefined && uniqueData !== null ? uniqueData.map((data: any, i: any) => {
                    if (i >= (50 * (currentPageNo - 1) && cnt < 50)) {
                        cnt++;

                        tempExportData.push({
                            'Alert Name': data[1],
                            'Number of Devices': data[0],
                        });

                        tempTableData.push({
                            checkbox: 'hide',
                            notification_name: {
                                label: <Button id="ButtonHover" style={buttonContent} appearance="transparent" size="small" onClick={() => {
                                    navigate("/manage/troubleshoot/alert/devices");
                                    localStorage.setItem('alertName', data[1]);
                                    contextValue.setSelectedRowDetails({
                                        ...contextValue.selectedRowDetails,
                                        id: data[2],
                                        name: data[1]
                                    });
                                }}> {data[1]} </Button>
                            },
                            num_of_devices: { label: <Caption1> {data[0].toString()} </Caption1> },
                        });
                    }
                }) : (tempTableData = []);
                setExportData(tempExportData);

                tempTableData.length > 0 ? setTableData(tempTableData) : setTableData([]);
                setLoading(false);
                setTotalRecords(uniqueData?.length);
                setTotalPages(Math.ceil((uniqueData?.length) / 50));
                setTimeout(() => {
                    setLoading(false);
                  }, 500);
                  // setLoading(false);
                  setRefreshing(false); // Reset refreshing state after data is fetched
                  setRefreshToast(false);
            } else {
                setLoading(false);
                setTableData([]);
                setTotalRecords(0);
                setTotalPages(0);
            }
        };

        fetchData();
    }, [searchVal, currentPageNo, isRefresh, refreshing]);

    var tempTableData: any = [];
    var menuLists: any = [];
    var tempExportData: any = [];

    //   useEffect(() => {
    //     // data table values append code starts here
    //     console.log("final_data=",final_data);

    //     final_data !== undefined && final_data !== null
    //       ? final_data.core_Census.map((val: any, i: any) => {
    //           menuLists.push();
    //  console.log("val.alerName=",val.alerName);

    //           tempExportData.push({
    //             notification_name: val.alerName,
    //             num_of_devices: val.nod,
    //           });



    //           tempTableData.push({
    //             checkbox:'hide',
    //             notification_name:{ label: <Button shape="circular" appearance="transparent" size="small" onClick={() => setOverlayOpen(true)}> {val.alerName} </Button> },
    //             num_of_devices: { label: <Caption1> {val.nod} </Caption1> },
    //           });
    //         }) : (tempTableData = []);
    //     setExportData(tempExportData);
    //     tempTableData.length > 0 ? setTableData(tempTableData) : (tempTableData = []);
    //   }, [final_data]);
    // data table values append code ends here

    //   useEffect(() => {
    //     console.log("tableData=",tableData);
    //     setLoading(false);
    //   }, [tableData]);

    // data table values append code ends here
    var overLayData: any = {

        headerTitle: "Memory usage greater than 90%",
        size: "large",
        isTabs: true,
        tabItems: {
            Introduction:
                <>
                    <Stack tokens={{ childrenGap: 15, padding: 10 }}>
                        <StackItem>
                            <Body1Strong>What does this Alert Do?</Body1Strong>
                        </StackItem>
                        <StackItem>
                            <Caption1>
                                This alert indicates that data in Office mobile apps may be shared or leaked to unmanaged apps on iOS and Android devices. In this scenario, data protection settings should be applied to your organization’s managed mobile apps to prevent such occurrences.
                            </Caption1>
                        </StackItem>
                        <StackItem>
                            <Body1Strong>What is the Benefit of Addressing this Alert?</Body1Strong>
                        </StackItem>
                        <StackItem>
                            <Caption1>
                                Addressing this alert helps prevent data in Office mobile apps from being shared or leaked to unmanaged apps on iOS and Android devices, ensuring better data security for your organization.
                            </Caption1>
                        </StackItem>
                    </Stack>
                </>,

            Devices:
                <>
                    <Stack tokens={{ childrenGap: 15, padding: 10 }}>
                        <Stack verticalAlign="center" tokens={{ childrenGap: 10 }}>
                            <StackItem>
                                <OverflowSetCustomExample overlayOpen={overlayOpen} setOverlayOpen={setOverlayOpen} component={overFlowComponent} />
                                <Divider />
                            </StackItem>
                            <StackItem>
                                <StackItem>
                                    <Stack horizontal tokens={{ childrenGap: 20 }}>   
                                        <SearchBar setCurrentPageNo={setCurrentPageNo} columnSearch={"for Name"} searchVal={searchVal} setSearchVal={setSearchVal} setLoading={setLoading} disabled={loading || tableData.length === 0}/>
                                        <StackItem>
                                            <MenuDropdown open={filterMenuOpen} btn={
                                                <MenuButton disabled={loading || tableData.length === 0} shape="circular" size="small" onClick={() => setFilterMenuOpen(true)}>
                                                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                                                        {loading || tableData.length === 0 ? <Filter20Filled {...secondaryIcon} /> : <Filter20Filled {...primaryIcon} />}
                                                        <Body1> Filter </Body1>
                                                    </Stack>
                                                </MenuButton>
                                            } itemVal={<><Body1Strong> Add a Filter </Body1Strong>
                                                <Divider />
                                                <MenuList>
                                                    <Stack tokens={{ childrenGap: 5 }}>
                                                        <StackItem> <Text></Text> </StackItem>
                                                        <StackItem> <Caption1> Filter </Caption1> </StackItem>
                                                        {/* <DropdownComponent optionData={columns} /> */}
                                                        <DropdownComponent optionData={columns1} setDropDownValue={setDropDownValue1} dropDownvalue={dropDownValue1} />
                                                        <StackItem> <Divider /> </StackItem>
                                                        <StackItem> <Caption1> Value </Caption1> </StackItem>
                                                        {/* <DropdownComponent optionData={columns} /> */}
                                                        <Input size='small' onChange={inputChange} name="filter" value={dropDownValue2} />
                                                        <StackItem> <Divider /> </StackItem>
                                                        <Stack tokens={{ childrenGap: 10 }} horizontal>
                                                            <StackItem> <Button shape="circular" appearance="primary" onClick={() => { handleFilterArray(); setFilterMenuOpen(false) }}> <Caption1> Apply </Caption1> </Button> </StackItem>
                                                            <StackItem> <Button shape="circular" onClick={() => setFilterMenuOpen(false)}> <Caption1> Cancel </Caption1> </Button> </StackItem>
                                                        </Stack>
                                                    </Stack>
                                                </MenuList>
                                            </>} />
                                        </StackItem>
                                        <StackItem>
                                            {filterArray.length > 0 && filterArray.map((item, index) => (
                                                <Button shape="circular" size="small">
                                                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                                                        <StackItem> {item} </StackItem>
                                                        <StackItem>
                                                            <Stack tokens={{ childrenGap: 1 }}>
                                                                <StackItem><Text></Text></StackItem>
                                                                <StackItem><Dismiss16Regular onClick={() => { handleCloseFilter(index) }} /></StackItem>
                                                            </Stack>
                                                        </StackItem>
                                                    </Stack>
                                                </Button>
                                            ))}
                                        </StackItem>
                                        <StackItem onClick={() => { setFilterArray([]); setIsFilter(false); setDropDownValue2(''); setResetDisabled(true); }}>
                                            <Button shape="circular" appearance="subtle" size="small" disabled={isResetDisabled}>
                                                <Stack tokens={{ childrenGap: 5 }} horizontal>
                                                    <StackItem> <FilterDismiss20Filled /> </StackItem>
                                                    <StackItem> <Caption1> Reset Filters </Caption1> </StackItem>
                                                </Stack>
                                            </Button>
                                        </StackItem>
                                    </Stack>
                                    <InfoBar title={"Executing the following troubleshooters will assist you in devices management and provide a resolutions for any errors. Be mindful  when executing the troubleshooter on multiple devices."} />
                                </StackItem>
                                <Stack tokens={{ childrenGap: 10 }}><StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem></Stack>
                                {tableData.length > 0 && <Stack horizontal enableScopedSelectors horizontalAlign="space-between" >
                                    <StackItem>
                                        <Caption1> Showing {(currentPageNo - 1) * 50 + 1} to {currentPageNo * 50 > totalRecords ? totalRecords : currentPageNo * 50} of {totalRecords} Records </Caption1>
                                    </StackItem>
                                    <StackItem>

                                        <Pagination setLoading={setLoading} totalPages={totalPages} currentPageNo={currentPageNo} setCurrentPageNo={setCurrentPageNo} />
                                    </StackItem>
                                </Stack>}
                            </StackItem>
                            {/* <StackItem>Data table comes here.</StackItem> */}
                            {/* {tableData.length > 0 && ( <DataTable tableData={tableData} columns={columns}/> )} */}
                            {loading ? (<SkeletonDataTable />) : tableData.length > 0 ? (<DataTable tableData={tableData} columns={columns} ></DataTable>) : <Stack horizontalAlign="center" tokens={{ childrenGap: 15, padding: 10 }}><StackItem><Text size={500}>No result.</Text></StackItem></Stack>}
                        </Stack>
                    </Stack>
                </>,
        },
        footerData:
            (
                <>
                    <Button shape="circular" appearance="primary" size="medium" onClick={() => {
                        setOverlayOpen(false);
                        setTimeout(() => {
                            navigate("/manage/troubleshoot/troubleshoot");
                        }, 1000);
                    }} > Troubleshoot Fix </Button>
                </>
            )
    };

    return (
        <>
            <FullScreen handle={handle} className="fullScreenBackgroundColor">
                <StackItem grow shrink style={BreadcrumbsBorder}>
                    <Stack tokens={{ childrenGap: 10 }} horizontal>
                        {contextValue?.logedInFrom?.platform !== "ServiceNow" && <StackItem grow shrink>
                            <Stack tokens={{ childrenGap: 5 }} horizontalAlign="start">
                                <StackItem><Text></Text></StackItem>
                                <StackItem grow shrink>
                                    <Breadcrumbs
                                        items={[
                                        { name: "Manage", link: "/home" },
                                        { name: "Troubleshoot", link: "#" },
                                        { name: "Alert", link: "#" }
                                        ]} 
                                    />
                                </StackItem>
                            </Stack>
                        </StackItem>}
                    </Stack>
                </StackItem>
                <FluentProvider style={responsiveHight} theme={dashboardTheme}>
                    <Stack style={DynamicBoxingCSS} tokens={{ childrenGap: 20, }} horizontal>
                        <StackItem style={DynamicBoxingCSS}>
                            {/* pages code starts here */}
                            <Stack style={DynamicBoxingCSS}>
                                <FluentProvider style={parentHome} theme={dashboardTheme}>
                                    <Stack style={parentHome} horizontal>
                                        {/* SPACING BETWEEN INLINE AND PAGE */}
                                        <SideMenu leftOpenSubMenu={leftOpenSubMenu} setleftOpenSubMenu={setleftOpenSubMenu} menuItems={TroubleshootPages("Alert")} />
                                        <StackItem style={DynamicBoxingCSS}>
                                            <Stack style={parentHome} tokens={{ childrenGap: 10 }}>
                                                <StackItem>
                                                    <OverflowSetCustomExample overlayOpen={overlayOpen} setOverlayOpen={setOverlayOpen} component={overFlowComponent} />
                                                    <Divider />
                                                </StackItem>
                                                <StackItem>
                                                    <StackItem style={wraperStyle}>
                                                        <Stack horizontalAlign="space-between" wrap horizontal tokens={{ childrenGap: 10 }}>
                                                            <Stack horizontal tokens={{ childrenGap: 10 }}>
                                                                <StackItem>
                                                                    <SearchBar setCurrentPageNo={setCurrentPageNo} columnSearch={"for Name"} searchVal={searchVal} setSearchVal={setSearchVal} setLoading={setLoading} disabled={loading || tableData.length === 0} />
                                                                </StackItem>
                                                                <StackItem>
                                                                    <MenuDropdown open={filterMenuOpen} btn=
                                                                        {
                                                                            <MenuButton disabled={loading || tableData.length === 0} shape="circular" size="small" onClick={() => setFilterMenuOpen(true)}>
                                                                                <Stack tokens={{ childrenGap: 5 }} horizontal>
                                                                                    {loading || tableData.length === 0 ? <Filter20Filled {...secondaryIcon} /> : <Filter20Filled {...primaryIcon} />}
                                                                                    <Body1> Filter </Body1>
                                                                                </Stack>
                                                                            </MenuButton>
                                                                        } itemVal={
                                                                            <>
                                                                                <Body1Strong> Add a Filter </Body1Strong>
                                                                                <Divider />
                                                                                <MenuList>
                                                                                    <Stack tokens={{ childrenGap: 5 }}>
                                                                                        <StackItem> <Text></Text> </StackItem>
                                                                                        <StackItem> <Caption1> Filter </Caption1> </StackItem>
                                                                                        <DropdownComponent optionData={columns1} setDropDownValue={(newValue) => { setDropDownValue1(newValue); setDropDownValue2(''); }} dropDownvalue={dropDownValue1} />
                                                                                        <StackItem> <Divider /> </StackItem>
                                                                                        <StackItem> <Caption1> Value </Caption1> </StackItem>
                                                                                        {(dropDownValue1 === "Alert Name") && <Input size='small' onChange={inputChange} name="filter" value={dropDownValue2} />}
                                                                                        {(dropDownValue1 === "Number of Alerts") && <Input size='small' onChange={inputChange} name="filter" value={dropDownValue2} />}
                                                                                        <StackItem> <Divider /> </StackItem>
                                                                                        <Stack tokens={{ childrenGap: 10 }} horizontal>
                                                                                            <StackItem>
                                                                                                <Button shape="circular" appearance="primary" onClick={() => { handleFilterArray(); setFilterMenuOpen(false); }}
                                                                                                    disabled={!dropDownValue1 || !dropDownValue2 || filterArray.some(filter => filter.startsWith(`${dropDownValue1}:`))}>
                                                                                                    <Caption1> Apply </Caption1>
                                                                                                </Button>
                                                                                            </StackItem>

                                                                                            <StackItem>
                                                                                                <Button shape="circular" onClick={() => { setFilterMenuOpen(false); setDropDownValue1(''); setDropDownValue2(''); }}>
                                                                                                    <Caption1> Cancel </Caption1>
                                                                                                </Button>
                                                                                            </StackItem>
                                                                                        </Stack>
                                                                                    </Stack>
                                                                                </MenuList>
                                                                            </>
                                                                        }
                                                                    />
                                                                </StackItem>
                                                                <StackItem onClick={() => { setFilterArray([]); setIsFilter(false); setDropDownValue2(''); setResetDisabled(true); }}>
                                                                    <Button shape="circular" appearance="subtle" size="small" disabled={isResetDisabled}>
                                                                        <Stack tokens={{ childrenGap: 5 }} horizontal>
                                                                            <StackItem> <FilterDismiss20Filled /> </StackItem>
                                                                            <StackItem> <Caption1> Reset Filters </Caption1> </StackItem>
                                                                        </Stack>
                                                                    </Button>
                                                                </StackItem>
                                                            </Stack>
                                                            {(tableData.length > 0 && !loading) && <StackItem> <Pagination setLoading={setLoading} totalPages={totalPages} currentPageNo={currentPageNo} setCurrentPageNo={setCurrentPageNo} /> </StackItem>}
                                                        </Stack>
                                                        <Stack horizontal horizontalAlign="space-between" tokens={{ padding: '10px 0px 0px 8px' }}>
                                                            <StackItem>
                                                                {filterArray.length > 0 && (
                                                                    <Stack horizontal wrap>
                                                                        {filterArray.map((item, index) => (
                                                                            <Button shape="circular" size="small">
                                                                                <Stack tokens={{ childrenGap: 5 }} horizontal>
                                                                                    <StackItem> {item.includes("00:00") ? item.split("00:00")[0].trim() : item} </StackItem>
                                                                                    <StackItem>
                                                                                        <Stack tokens={{ childrenGap: 1 }}>
                                                                                            <StackItem><Text></Text></StackItem>
                                                                                            <StackItem><Dismiss16Regular onClick={() => { handleCloseFilter(index) }} /></StackItem>
                                                                                        </Stack>
                                                                                    </StackItem>
                                                                                </Stack>
                                                                            </Button>
                                                                        ))}
                                                                    </Stack>
                                                                )}
                                                            </StackItem>
    
                                                            <StackItem disableShrink>
                                                                {(tableData.length > 0 && !loading) && (
                                                                    totalRecords > 0 &&
                                                                    <Caption1>
                                                                        Showing {((currentPageNo - 1) * 50) + 1} to {(currentPageNo * 50) > totalRecords ? totalRecords : (currentPageNo * 50)} of {totalRecords} Records
                                                                    </Caption1>
                                                                )}
                                                            </StackItem>
                                                        </Stack>
                                                    </StackItem>
                                                </StackItem>
                                                {/* <Census_func data={final_data} func={set_final_data} searchVal={searchVal} pageNo = {(currentPageNo - 1) * 10} setTotalPages = {setTotalPages} setTotalRecords = {setTotalRecords} /> */}
                                                {/* {tableData.length > 0 && ( <DataTable tableData={tableData} columns={columns}/> )} */}
                                                {loading ? (<SkeletonDataTable />) : tableData.length > 0 ? (<DataTable tableData={tableData} columns={columns} />) : <Stack horizontalAlign="center" tokens={{ childrenGap: 15, padding: 10 }}><StackItem><Text size={500}>No result.</Text></StackItem></Stack>}

                                            </Stack>

                                        </StackItem>
                                    </Stack>
                                </FluentProvider>
                            </Stack>
                            <OverLay overlayopen={overlayOpen} setOverlayOpen={setOverlayOpen} overlayData={overLayData} />
                        </StackItem>
                        <StackItem><Text></Text></StackItem>
                        {refreshToast && <ToastComponent setmessagebar={setIsToast} isToastEnabled={refreshToast} toastIntent="success" position="top-end" title="Success" message={'Data Table Refreshed'} footer="" />}
                        
                    </Stack>
                </FluentProvider>
            </FullScreen>
        </>
    );
};
